import { PrinterType } from '../Models/SkitterbookLivePagesRequest';
import { RadioGroup } from "../Controls/RadioGroup";
import './css/SkitterBookPrinterType.css';

interface SkitterBookPrinterTypeProps {
    value: PrinterType;
    onChange?: (value: PrinterType) => void;
}

export const SkitterBookPrinterType: React.FC<SkitterBookPrinterTypeProps> = ({
    value,
    onChange
}) => {
    return (
        <div className="sbpt-container sbpt-PrinterType-container">
            <RadioGroup<PrinterType>
                name="PrinterTypeGroup"
                value={value}
                onChange={(val: PrinterType) => {
                    onChange?.(val);
                }}
                options={[
                    { value: "SINGLE", label: <div className="skpspage-image"><span>No, just one side</span></div> },
                    { value: "DUPLEX", label: <div className="skpspage-image"><span>Yes, both Sides</span></div> }
                ]}
                colors={{
                    border: "var(--color-static-background)",
                    foreground: "var(--color-component-foreground)",
                    background: "var(--color-component-background)",
                    hover: "var(--color-component-foreground)"
                }}
                className="PrinterType-group"
            />
        </div>
    );
};

export default SkitterBookPrinterType;
